import "./namespace.js";
import "#/legacy/namespaces.js";
import "#legacy/utilities/request_locale.js";

DoctorFinder.Helpers.AutocompleteDataFetcher = class AutocompleteDataFetcher {
  constructor(params) {
    this.load = this.load.bind(this);
    this.fetchWithRetry = this.fetchWithRetry.bind(this);
    this.assignDataFromLookup = this.assignDataFromLookup.bind(this);
    this.ready = this.ready.bind(this);
    this.params = params;
    this.deferred = new jQuery.Deferred();
    this.promise = this.deferred.promise();
  }

  load(callback) {
    this.data = {};
    this.lookup = {};
    this.visitTypes = [];
    this.providerTypes = [];

    if (callback) {
      this.ready(callback);
    }

    if (!this.loading) {
      this.loading = true;

      const _autocompleteDataUrl = window.Sparkle.apiHost
        ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.autocompleteData
        : window.SparkleConfig.routes.embed.autocompleteData;
      const _autocompleteLookupUrl = window.Sparkle.apiHost
        ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.autocompleteLookup
        : window.SparkleConfig.routes.embed.autocompleteLookup;
      const _filtersProviderSearchUrl = window.Sparkle.apiHost
        ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.filtersPhysiciansProviderSearch
        : window.SparkleConfig.routes.embed.filtersPhysiciansProviderSearch;

      const dataFetch = this.fetchWithRetry(_autocompleteDataUrl, this.params);
      dataFetch.then((data) => {
        this.data = data;
      }); // Populate data

      const lookupFetch = this.fetchWithRetry(_autocompleteLookupUrl);
      lookupFetch.then((lookup) => {
        this.lookup = lookup;
      }); // Populate lookup

      const providerFiltersFetch = this.fetchWithRetry(_filtersProviderSearchUrl);
      providerFiltersFetch.then((data) => {
        this.visitTypes = data.visit_types.filter((visitType) => visitType.visible);
        return (this.providerTypes = data.provider_types);
      });

      jQuery.when(dataFetch, lookupFetch, providerFiltersFetch).then(() => {
        this.assignDataFromLookup("Physician", "physicians", "physician_ids");
        this.assignDataFromLookup("Location", "locations", "location_ids");

        this.data.visit_types = this.visitTypes.map((visitType) => ({
          text: visitType.text,
          filters: { availability: true, visit_types: visitType.value },
          type: "VisitType",
          group: DoctorFinder.prototype.I18n.t("doctor_finder.labels.autocomplete_dropdown.ehr_visit_types"),
          visibility: "query",
        }));
        this.data.provider_types = this.providerTypes.map((providerType) => ({
          text: providerType.text,
          filters: { provider_type: providerType.value },
          type: "ProviderType",
          group: DoctorFinder.prototype.I18n.t("doctor_finder.labels.autocomplete_dropdown.provider_types"),
          visibility: "query",
        }));

        return this.deferred.resolve(this.data);
      });
    }

    return this.promise;
  }

  fetchWithRetry(url, params = {}) {
    const deferred = new jQuery.Deferred();
    const resolver = (data) => deferred.resolve(data);

    jQuery.ajax({
      dataType: "json",
      url,
      data: params,
      statusCode: {
        204: () => setTimeout(2000, () => this.fetchWithRetry(url).then(resolver)), // Data still being processed, check again in a bit
        200: resolver,
        304: resolver,
      },
    });

    return deferred.promise();
  }

  assignDataFromLookup(type, lookupKey, idsKey) {
    const { href } = this.lookup.base;
    // The live url redirects to the record's page in the page's locale.
    const locale = Sparkle.Utilities.requestLocale();
    const localeQuery = locale ? `&locale=${encodeURIComponent(locale)}` : "";
    this.data[lookupKey] = _.values(_.pick(this.lookup[lookupKey], this.data[idsKey]));

    return (() => {
      const result = [];
      for (var id in this.lookup[lookupKey]) {
        var record = this.lookup[lookupKey][id];
        Object.assign(record, this.lookup.base[lookupKey]);
        record.url = `${href}/live_url?id=${id}&type=${type}${localeQuery}`;
        if (record.icon != null) {
          result.push((record.icon = href + record.icon));
        } else {
          result.push(undefined);
        }
      }
      return result;
    })();
  }

  ready(callback) {
    this.promise.then(callback);

    return this.promise;
  }
};
